export default "__VITE_ASSET__BdzIIwzH__"